import { Account } from '@/domain/usecases'
import { OnboardingOptions } from '@/domain/usecases/onboarding/onboarding-options'
import { QueryClient } from 'react-query'
import OnboardingBaseLoader from './onboarding-base-loader'

export default class OnboardingStepOptionsLoader extends OnboardingBaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    private readonly step: 1 | 3 | 4
  ) {
    super(account, queryClient)
  }

  async loader() {
    return this.defer({
      data: super
        .importRemoteModule('makeRemoteOnboardingOptions')
        .then(async makeRemoteOnboardingOptions => {
          const remoteOnboardingOptions = makeRemoteOnboardingOptions(
            this.queryClient
          ) as OnboardingOptions
          return remoteOnboardingOptions[`getStep${this.step}`]()
        })
    })
  }
}
